import { SetUserRoutine} from '../redux-routines';

const initialState = {
  user: null,
  isFetching: false,
  error: null,
};

const userstore = (state = initialState, action) => {
  switch (action.type) {
    case SetUserRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload,
        error: null
      };
    case SetUserRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SetUserRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};


export default userstore;
